import React from 'react';
import { useTranslation } from 'react-i18next';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import { ReactComponent as IconProfile } from '../../images/icn_profilo.svg';
import SearchInput from '../../commons/SearchInput';
import { Col, CustomInput, FormGroup, Row } from 'reactstrap';
import { ContPaginationPage } from '../../styled-components';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import ContactsTable from './ContactsTable';

const ContactsPresentational = ({
  data,
  profile,
  query,
  total,
  onFilter,
  updateContacts,
}) => {
  const [t] = useTranslation('MARKETING');
  const { offset, limit } = query;

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <Header
          title={t('PAGES:CONTACTS')}
          icon={<IconProfile fill="#ffffff" style={{ height: '25px' }} />}
        />

        <section>
          <Row className="search-add-cont m-t-20">
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.email }}
                onFilter={({ search }) => onFilter({ email: search })}
                label={t('SEARCH:BY_EMAIL')}
              />
            </Col>
          </Row>
        </section>

        <section className="m-t-20 table-page" style={{ height: '80vh' }}>
          <ContactsTable
            data={data}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            profile={profile}
            updateContacts={updateContacts}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={query.limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
      </div>
    </div>
  );
};

export default ContactsPresentational;
